const state = {
  errors: [],
  appLoad: false,
  step: 0,
  sessionSettings: {
    vat: 20,
    showPayPalOnlinePaymentOption: false,
    dimensions: {
      type: 0,
      weight: 0.3,
      int_dox_max_piece_weight: 30,
      int_dox_min_piece_weight: 0.3,
      int_wpx_max_piece_weight: 70,
      int_wpx_min_piece_weight: 0.5,
      dom_max_piece_weight: 50,
      dom_min_piece_weight: 0.5,
      min_size: 1,
      max_size_big: 120,
      max_size_small: 80,
    },
    insurance: {
      default_extra_charge_cost: 650,
      default_price: 10000,
      maximum_price: 35000000,
      minimum_price: 1000,
      minimum_price_treshold: 650,
      maximum_price_treshold: 65000,
      percent: 0.01,
    },
    productsRestrictions: [
      { productLocalCode: '7', maxWeightKg: 2, shipmentType: 0 },
    ],
  },
};

export default state;
